import * as client from "../../../client";
import { ClientId, perClient } from "../../../client-features";

const REQUIRED_FIELDS = perClient({
  bluesky: [
    "aop_deductible",
    "premises_number",
    "building_number",
    "street_address",
    "city",
    "state",
    "zip",
    "year_built",
    "building_description",
    "construction_description",
    "cooking_class",
  ],
});

export const isRequiredField = (
  clientId: ClientId,
  field: keyof client.RawAddress | undefined
): boolean => {
  const requiredFields = REQUIRED_FIELDS[clientId] ?? [];
  return field !== undefined && requiredFields.includes(field);
};
